// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as B20261104RouteImport } from './routes/b-2026-11-04'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as MembersRouteImport } from './routes/members'
import { Route as MhRouteImport } from './routes/mh'
import { Route as NewDiplomatsRouteImport } from './routes/new-diplomats'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RegistrationConfirmedRouteImport } from './routes/registration-confirmed'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as DotwellKnownSecurityDottxtRouteImport } from './routes/[.]well-known.security[.]txt'
import { Route as ApiEventTextRouteImport } from './routes/api/event-text'
import { Route as MeetingsIndexRouteImport } from './routes/meetings.index'
import { Route as MeetingsSlugRouteImport } from './routes/meetings.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const B20261104Route = B20261104RouteImport.update({
            id: '/b-2026-11-04',path: '/b-2026-11-04',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ImprintRoute = ImprintRouteImport.update({
            id: '/imprint',path: '/imprint',getParentRoute: () => rootRouteImport
          })
const MembersRoute = MembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => rootRouteImport
          })
const MhRoute = MhRouteImport.update({
            id: '/mh',path: '/mh',getParentRoute: () => rootRouteImport
          })
const NewDiplomatsRoute = NewDiplomatsRouteImport.update({
            id: '/new-diplomats',path: '/new-diplomats',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RegistrationConfirmedRoute = RegistrationConfirmedRouteImport.update({
            id: '/registration-confirmed',path: '/registration-confirmed',getParentRoute: () => rootRouteImport
          })
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
            id: '/sitemap.xml',path: '/sitemap.xml',getParentRoute: () => rootRouteImport
          })
const DotwellKnownSecurityDottxtRoute = DotwellKnownSecurityDottxtRouteImport.update({
            id: '/.well-known/security.txt',path: '/.well-known/security.txt',getParentRoute: () => rootRouteImport
          })
const ApiEventTextRoute = ApiEventTextRouteImport.update({
            id: '/api/event-text',path: '/api/event-text',getParentRoute: () => rootRouteImport
          })
const MeetingsIndexRoute = MeetingsIndexRouteImport.update({
            id: '/meetings/',path: '/meetings/',getParentRoute: () => rootRouteImport
          })
const MeetingsSlugRoute = MeetingsSlugRouteImport.update({
            id: '/meetings/$slug',path: '/meetings/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AuthRoute: AuthRoute,B20261104Route: B20261104Route,ContactRoute: ContactRoute,ImprintRoute: ImprintRoute,MembersRoute: MembersRoute,MhRoute: MhRoute,NewDiplomatsRoute: NewDiplomatsRoute,PrivacyRoute: PrivacyRoute,RegistrationConfirmedRoute: RegistrationConfirmedRoute,SitemapDotxmlRoute: SitemapDotxmlRoute,DotwellKnownSecurityDottxtRoute: DotwellKnownSecurityDottxtRoute,ApiEventTextRoute: ApiEventTextRoute,MeetingsSlugRoute: MeetingsSlugRoute,MeetingsIndexRoute: MeetingsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)